export default "__VITE_ASSET__Bmvxa3K2__"